import React from "react"
import styled from "styled-components"
import { FormattedMessage } from "react-intl"
import Box from "../../lib/ui/ui-box"
import Text from "../text"

// Link + Popup
const LegalRolloverContainer = styled(Box)`
  display: inline-block;
  position: relative;
  :hover {
    .hidden {
      display: flex;
    }
  }
`

// Link
const FormattedMessageLink = styled(Text)`
  display: inline-flex;
  color: #f7b44e;
  margin-left: 6px;
  :hover {
    text-decoration: underline;
    cursor: default;
  }
`

// Popup
const RolloverPopup = styled(Box)`
  position: absolute;
  display: none;
  flex-direction: column;
  bottom: 115%;
  left: 6px;
`

// Text Box
const RolloverPopupTextBox = styled(Box)`
  display:inline-block;
  width: 220px;
  background-color: #f7b44e;
  padding: 8px 14px;
`

// Arrow
const RolloverPopupArrow = styled(Box)`
  display: inline-block;
  position: relative;
  top: -3px;
  left: -8px;
  width: 0;
  height: 0;
  border-left: 12px solid transparent;
  border-right: 12px solid transparent;
  border-bottom: 12px solid #f7b44e;
  transform: rotate(-45deg);
`

const LegalRollover = () => {
  return (
    <LegalRolloverContainer className="main">
      {/* Link */}
      <FormattedMessageLink style={{ "display": "inline-block" }}>
        <FormattedMessage id="howitworks.step3.legalRolloverLink" />
      </FormattedMessageLink>
      {/* Popup */}
      <RolloverPopup className="hidden">
        {/* Text Box */}
        <RolloverPopupTextBox>
          {/* Text */}
          <Text color="white" fontSize={1}>
            <FormattedMessage id="howitworks.step3.legalRollover" />
          </Text>
        </RolloverPopupTextBox>
        {/* Arrow */}
        <RolloverPopupArrow />
      </RolloverPopup>
    </LegalRolloverContainer>
  )
}

const FormattedMessageWithLink = () => {
  return (
    <Box
      style={{ display: "inline-block" }}
      flexDirection="row"
      alignItems="center"
    >
      <FormattedMessage id="howitworks.step3.benefit1" />
      <LegalRollover />
    </Box>
  )
}

export default [
  // First
  {
    number: "1",
    title: () => <FormattedMessage id="howitworks.step1.title" />,
    description: <FormattedMessage id="howitworks.step1.description" />,
    benefits: [],
    perks: []
  },
  // Second
  {
    number: "2",
    title: () => <FormattedMessage id="howitworks.step2.title" />,
    description: <FormattedMessage id="howitworks.step2.description" />,
    benefits: [],
    perks: []
  },
  // Third
  {
    number: "3",
    title: () => <FormattedMessage id="howitworks.step3.title" />,
    description: "",
    benefits: [
      {
        title: () => <FormattedMessageWithLink id="howitworks.step3.benefit1" />
      },
      {
        title: () => <FormattedMessage id="howitworks.step3.benefit2" />
      },
      {
        title: () => <FormattedMessage id="howitworks.step3.benefit3" />
      },
      {
        title: () => <FormattedMessage id="howitworks.step3.benefit4" />
      }
    ],
    perks: []
  },
  // Fourth
  {
    number: "4",
    title: () => <FormattedMessage id="howitworks.step4.title" />,
    description: <FormattedMessage id="howitworks.step4.description" />,
    benefits: [],
    perks: []
  },
  // Fifth
  {
    number: "5",
    title: () => <FormattedMessage id="howitworks.step5.title" />,
    description: <FormattedMessage id="howitworks.step5.description" />,
    benefits: [],
    perks: []
  }
]



// WEBPACK FOOTER //
// ./src/components/how-it-works/data.js